/**
 * Returns the inventoryType of the vehicle.
 *
 * @param {Object} vehicle Vehicle object
 * @returns {String} The inventoryType of the vehicle
 */
const getInventoryType = ({ newOrUsed, certified, condition }) => {
	let inventoryType;

	if (newOrUsed) {
		inventoryType =
			certified === 'true' || certified === true
				? 'certified'
				: newOrUsed;
	} else if (condition) {
		inventoryType =
			certified === 'true' || certified === true ? 3 : condition;
	}

	return inventoryType;
};

export default getInventoryType;
